import React, { Component } from 'react';

/**
 * Tiny badge button shown next to the chapter SummaryBadge.
 * Indicates how many writer submissions are pending review for this chapter.
 *
 * Props:
 * - count: number — number of pending submissions
 * - onClick: (e) => void
 */
export default class SubmissionsBadge extends Component {
  render() {
    const { count = 0, onClick } = this.props;
    if (!count || count <= 0) return null;

    const label = count === 1 ? '1 submission' : `${count} submissions`;
    return (
      <button
        type="button"
        className="submissions-badge"
        onClick={(e) => {
          e.stopPropagation();
          onClick?.(e);
        }}
        title={`${label} pending review — click to review`}
        aria-label={`${label} pending review`}
      >
        <svg
          className="submissions-badge-icon"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          {/* Tray outline */}
          <path d="M3 13l3-8h12l3 8" />
          <path d="M3 13v6a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-6" />
          {/* Slot lip where the page enters */}
          <path d="M3 13h5l1.5 2h5L16 13h5" />
          {/* Incoming page arrow */}
          <path d="M12 3v6" />
          <path d="M9 7l3 3 3-3" />
        </svg>
        <span className="submissions-badge-text">{count}</span>
      </button>
    );
  }
}
